import { put } from 'redux-saga/effects';
// internal
import * as ActionType from '@app/store/typings/actions/permission.d';
import * as permissionService from '@app/services/permission';
import { handleError } from '@app/utils/service';

export function* fetchBrandPermission() {
  try {
    const { data } = yield permissionService.fetchBrandPermission();
    if (data.success) {
      yield put<ActionType.PermissionType>({
        type: 'KEY_PERMISSION_BRAND_SETDATA',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchProjectPermission() {
  try {
    const { data } = yield permissionService.fetchProjectPermission();
    if (data.success) {
      yield put<ActionType.PermissionType>({
        type: 'KEY_PERMISSION_PROJECT_SETDATA',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}
